<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <tippy>
        <div class="lsn-table__tag">
            {{ $t(`order_table.status.${status.code}.label`) }}
        </div>

        <template #content>
            <div class="text-gray-500 text-center space-y-1">
                <div v-if="$store.getters['account/isDeveloper']" class="text-gray-400">
                    {{ status.code }}
                </div>
                <div>
                    {{ statusAt }}
                </div>
            </div>
        </template>
    </tippy>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

import moment from 'moment';

export default
{
    name: 'OrderStatusCell',

    props:
    {
        row:
        {
            type:     Object,
            required: true,
        },

        rows:
        {
            type:     Array,
            required: true,
        },

        column:
        {
            type:     Object,
            required: true,
        },

        updating:
        {
            type:    Boolean,
            default: false,
        },
    },

    computed:
    {
        status()
        {
            return [].concat(this.row.status).pop(); // last status
        },

        statusAt()
        {
            return moment(this.status.at).format('DD.MM.YYYY | HH:MM');
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style scoped>
@reference "#main.css";


.lsn-table__tag
{
    @apply text-xs;
}

</style>
